const LINK_DIVIDER = "|";

const hasTextSpecialCharacters = (text) => text.includes("@{");
const getTextTransformed = (textData, verifiedTextFunc) => textData && hasTextSpecialCharacters(textData) ? verifiedTextFunc(textData.split("@")).join("") : textData;

const isTextLinkData = (text) => text.includes(LINK_DIVIDER);
const getLinkParts = (text) => text.replace(/{"|"}/gi, "").split(`"${LINK_DIVIDER}"`);

const getFullLink = (linkText) => linkText.map((item) => {
	if (isTextLinkData(item)) {
		const [ linkLabel, linkUrl ] = getLinkParts(item);

		return linkUrl ? `<a href=${linkUrl} class="highlight">${linkLabel}</a>` : `<span class="item__text--highlight">${linkLabel}</span>`;
	} else {
		return item;
	}
});

const getLabelLink = (linkText) => linkText.map((item) => {
	if (isTextLinkData(item)) {
		return getLinkParts(item)[0];
	} else {
		return item;
	}
});

export const getTextMetadataDataTransformed = (textData) => getTextTransformed(textData, getFullLink);
export const getSpecialCharactersRemoved = (textData) => getTextTransformed(textData, getLabelLink);


// WEBPACK FOOTER //
// ./src/scripts/TextMetadata.js